module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "main-title"
  }, [_vm._v("个人信息")]), _vm._v(" "), _c('div', {
    staticClass: "com-model"
  }, [_c('div', {
    staticClass: "content-item flex flex-between align-end"
  }, [_c('div', {
    staticClass: "c-m-l flex"
  }, [_c('div', {
    staticClass: "avator-box"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/wapi/base/upload/headImage",
      "name": "headImageFile",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.hrimg) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.hrimg
    }
  }) : _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": require("../../assets/images/face.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "change-btn"
  }, [_vm._v("修改")])], 1), _vm._v(" "), _c('div', {
    staticClass: "name-phone"
  }, [_c('div', {
    staticClass: "flex name"
  }, [_c('span', [_vm._v(_vm._s(_vm.hrnames))]), _vm._v(" "), _c('img', {
    staticClass: "edit",
    attrs: {
      "src": require("../../assets/images/icon_edit.png"),
      "alt": "edit"
    },
    on: {
      "click": _vm.openDialogName
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("绑定手机：" + _vm._s(_vm.hrinfo.phone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-m-l flex wx-c-m"
  }, [_c('span', [_vm._v("绑定微信：" + _vm._s(_vm.hrinfo.isBindWechat ? _vm.hrinfo.phone : '未绑定'))]), _vm._v(" "), (!_vm.hrinfo.isBindWechat) ? _c('span', {
    staticClass: "s-d",
    on: {
      "click": function($event) {
        _vm.showWxBindBox = !_vm.showWxBindBox
      }
    }
  }, [_vm._v("立刻绑定")]) : _vm._e(), _vm._v(" "), (!_vm.hrinfo.isBindWechat && _vm.showWxBindBox) ? _c('div', {
    staticClass: "wx-box"
  }, [_c('div', {
    staticClass: "qr-tips"
  }, [_vm._v("打开微信扫描验证码完成验证")]), _vm._v(" "), _c('div', {
    staticClass: "qr"
  }, [_c('wechartQR', {
    attrs: {
      "id": "login_container",
      "redirect-path": "/index/home/person"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-m-l flex"
  }, [_c('span', [_vm._v("登录密码：")]), _vm._v(" "), _c('span', {
    staticClass: "s-d",
    on: {
      "click": _vm.modifyPassword
    }
  }, [_vm._v("修改密码")])])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-item flex flex-between"
  }, [_c('div', {
    staticClass: "lef"
  }, [_c('div', {
    staticClass: "lef-t flex"
  }, [_c('span', {
    staticClass: "text-name"
  }, [_vm._v("消息免打扰")]), _vm._v(" "), (_vm.hrinfo.notDisturbStatus) ? _c('span', {
    staticClass: "text-open"
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  }), _vm._v("已开启")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "lef-b flex"
  }, [_c('img', {
    staticClass: "icon_warn",
    attrs: {
      "src": require("../../assets/images/icon_msg_warn.png"),
      "alt": "icon_warn"
    }
  }), _vm._v("\n                    " + _vm._s(((_vm.hrinfo.notDisturbStatus ? '沟通免打扰开启中' : '开启沟通免打扰') + "，免打扰时段19:00-次日8:00")) + "\n                ")])]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "on-value": 1,
      "off-value": 0,
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.handleStatusChange
    },
    model: {
      value: (_vm.hrinfo.notDisturbStatus),
      callback: function($$v) {
        _vm.$set(_vm.hrinfo, "notDisturbStatus", $$v)
      },
      expression: "hrinfo.notDisturbStatus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-item flex flex-between"
  }, [_c('div', {
    staticClass: "text-name"
  }, [_vm._v("所在公司")]), _vm._v(" "), _c('div', {
    staticClass: "flex add-company pointer flex-center",
    on: {
      "click": _vm.addCompany
    }
  }, [_c('i', {
    staticClass: "el-icon-view"
  }), _vm._v("\n                加入新企业\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-item flex flex-wrap m-t-23"
  }, _vm._l((_vm.compyList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "company-item flex",
      class: {
        'active': item.shortName === _vm.hrinfo.companyShortname
      },
      on: {
        "click": function($event) {
          _vm.changeCompany(item)
        }
      }
    }, [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": item.logo
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "rig-box"
    }, [_c('div', {
      staticClass: "name flex"
    }, [_c('span', [_vm._v(_vm._s(item.shortName))]), _vm._v(" "), (item.shortName === _vm.hrinfo.companyShortname) ? _c('span', {
      staticClass: "login-tag"
    }, [_c('i', {
      staticClass: "el-icon-circle-check"
    }), _vm._v("已登录")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "post"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('div', {
      class: ['role', _vm.roleBgClass(item.roleName)]
    }, [_vm._v(_vm._s(item.roleName))])])])
  })), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-name",
    attrs: {
      "title": "修改昵称",
      "size": "large"
    },
    model: {
      value: (_vm.toggleName),
      callback: function($$v) {
        _vm.toggleName = $$v
      },
      expression: "toggleName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入昵称"
    },
    model: {
      value: (_vm.hrnames2),
      callback: function($$v) {
        _vm.hrnames2 = $$v
      },
      expression: "hrnames2"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.toggleName = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeName
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4462898c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/person.vue
// module id = 873
// module chunks = 1